import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const LoginForgotNoAccountContainer = styled('section')`
  ${flexCenter}

  flex-direction: column;
  height: auto;
  padding: 0 16px;
  padding-inline: 16px;
  text-align: left;

  & > p {
    margin-bottom: 24px;
  }

  ${mediaQuery('', 'mobile')} {
    padding: 0;
    padding-inline: 0;
  }

  ${mediaQuery('tablet', 'mobile')} {
    max-width: 548px;
    padding: 0 16px;
  }

  ${mediaQuery('', 'tablet')} {
    max-width: 548px;
  }

  ${mediaQuery('', 'laptop')} {
    max-width: 576px;
  }
`

const LoginForgotNoAccountTitle = styled('h3')`
  margin: 24px 0;
  margin-block: 24px;
  text-align: left;
  width: inherit;

  ${mediaQuery('', 'laptop')} {
    margin-top: 48px;
    margin-block-start: 48px;
  }
`

const LoginForgotNoAccountButton = styled('div')`
  width: 50%;

  ${mediaQuery('mobile')} {
    width: 100%;
  }

  & > button {
    width: 100%;
  }
`

export {
  LoginForgotNoAccountContainer,
  LoginForgotNoAccountTitle,
  LoginForgotNoAccountButton
}
